import { isProd } from '@agria/utils';

const siteLinksDev = {
  brochureware: 'https://www.cruftspetinsurance.co.uk',
  makeAPayment: 'https://kc-make-a-payment.netlify.app',
  onlineVetCLaims: 'https://vetclaim.cruftspetinsurance.co.uk',
  onlineCustomerClaims: 'https://claim.cruftspetinsurance.co.uk',
  quoteAndBuy: 'https://kc-qab.netlify.app',
  quoteAndBuyContinueCover: 'https://kc-qab.netlify.app/continue-cover',
  quoteAndBuyRetrieve: 'https://kc-qab.netlify.app/retrieve',
  freeCover: 'https://kc-owner-activated.netlify.app',
  rehomingCover: null,
  vetActivatedCover: null,
  breederClub: 'https://kc-breeder-club.netlify.app',
  vetOwnerActivated: null,
  litterDataCapture: 'https://litter-data-capture.cruftspetinsurance.co.uk/',
  joinBreederClub: 'https://kc-join-breeder-club.netlify.app/signup-type',
  transferCover: 'https://kc-transfer-cover.netlify.app',
  myAccount: 'https://www.cruftspetinsurance.co.uk/my-account',
  stock: 'https://stock.cruftspetinsurance.co.uk/login.html',
  vetEnvoy: 'https://www.vetenvoy.com/',
  myRewards: 'https://cruftspetinsurancerewards.co.uk/',
};

const siteLinksProduction = {
  ...siteLinksDev,
  quoteAndBuy: 'https://quote.cruftspetinsurance.co.uk',
  quoteAndBuyContinueCover:
    'https://quote.cruftspetinsurance.co.uk/continue-cover',
  quoteAndBuyRetrieve: 'https://quote.cruftspetinsurance.co.uk/retrieve',
  brochureware: 'https://www.cruftspetinsurance.co.uk',
  freeCover: 'https://owners.cruftspetinsurance.co.uk',
  breederClub: 'https://breeders.cruftspetinsurance.co.uk',
  joinBreederClub: 'https://join.cruftspetinsurance.co.uk/signup-type',
  transferCover: 'https://transfer-cover.cruftspetinsurance.co.uk',
};
export const siteLinks = isProd ? siteLinksProduction : siteLinksDev;
